import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const SCORE_CARDS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('SCORE_CARDS');
export const SCORE_CARDS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	SCORE_CARDS_CRUD_ACTION_CONSTANTS
);
